export const required = (value) =>
  value || value === 0 ? undefined : "Champ requis";

export const email = (value) =>
  value && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)
    ? "Adresse email non valide"
    : undefined;

export const companynumber = (value) =>
  value && !/^\d{8,}$/i.test(value) ? "siret invalide" : undefined;

export const date = (testdate) => {
  const dateRegex =
    /^([0-2][0-9]|(3)[0-1])(\/)(((0)[0-9])|((1)[0-2]))(\/)\d{4}$/i;
  return testdate && !dateRegex.test(testdate)
    ? "Date de naissance invalide. ex: 01/01/1990"
    : undefined;
};

export const subdomain = (testSubdomain) => {
  const subdomainRegex = /^([A-Z0-9-]+)$/i;
  return testSubdomain && !subdomainRegex.test(testSubdomain)
    ? "Sous-domaine non valide. ex: xxxxxxx"
    : undefined;
};

export const phonenumber = (phone) => {
  const phoneRegex = /0[1-9]\d{8}/;
  return phone && !phoneRegex.test(phone)
    ? "Numéro de téléphone non valide. ex: xxxxxxx"
    : undefined;
};



// WEBPACK FOOTER //
// ./src/pages/utils/form/formValidation.js